const messages = {
  "title": "Over Bridgestone <span class='text-danger'>Plus</span>",
  "description": "Bestel uw Bridgestone en Firestone banden bij één van de deelnemende distributeurs en profiteer van de vele voordelen van <b>BRIDGESTONE <span class='text-danger'>PLUS</span></b>.",
  "sections": {
    "first": {
      "title": "Betrouwbare leveringen voor u en uw klanten"
    },
    "second": {
      "title": "Uitstekende banden in het premium- en middensegment"
    },
    "third": {
      "title": "Interessant puntenprogramma",
      "description": "Uitgebreide mogelijkheden voor exclusieve winkelervaringen en uw digitale aanwezigheid op relevante touchpoints.",
      "subtitle": "Onze bewezen verkooppromoties",
      "pointInfo": "Profiteer van extra verkoopargumenten en uw klanten van spannende bonus- en meerwaardeacties.",
      "numberInfo": "Digitale directe verwerking met uw klant – geen extra inspanning voor u!",
      "subtitle2": "Sterke uitstraling met onze verkoopruimte-inrichting",
      "description2": "Presenteer uw verkoopruimte sfeervol en bied uw klanten een aangenaam verblijf met onze modules voor balieruimtes, expositieruimtes, wacht- en buitenruimtes en digitale oplossingen!",
      "description3": "Spaar punten en <b>promoot uw bedrijf</b>, samen met ons."
    },
    "fourth": {
      "title": "ALLES OP ÉÉN PLATFORM: HET BRIDGESTONE PLUS PORTAAL",
      "description": "Met uw persoonlijke toegang tot het online portaal heeft u direct toegang tot het diverse aanbod van BRIDGESTONE <span class='text-danger'>PLUS</span>.",
      "list": {
        "program": "Punten programma",
        "shop": "Bridgestone <span class='text-danger'>Plus</span> Shop",
        "priceList": "Prijslijst",
        "productInfo": "Productinformatie",
        "salePromotion": "Verkoopondersteuning",
        "onlineTrainings": "Online training",
        "andMore": "en nog veel meer."
      },
      "title2": "Regelmatige online trainingen",
      "description2": "Blijf altijd op de hoogte en profiteer samen met uw team van de online trainingen van Bridgestone "
    },
    "points": {
      "title": "Actuele online trainingen op het gebied van producten en verkoop:",
      "list": {
        "one": "Verkoop training",
        "two": "Bandenconstructies",
        "three": "Herken schadepatronen"
      },
      "subtitle": "UW DEELNAME WORDT BELOOND",
      "description": "Voor elke voltooide online training ontvang je <b>40 punten</b> en een <b>certificaat van deelname</b>!"
    },
    "firstStop": {
      "title": "Bridgestone bandengarantie",
      "description": "Voorwaarden 24 maanden garantie op Bridgestone banden bij First Stop Benelux"
    }
  },
  "fullPremium": "Bijna 80% van de verkochte Bridgestone banden heeft een <b>A-label voor grip op nat wegdek.</b>"
};

export default {
  messages,
};
